import {Assign} from 'utility-types';
import {UPDATE_SELECTED_PROPERTY} from '../../hotels-details-reducer/src/constants';

import {
  QueryParamsForReviewUrlPropsTypes,
  QueryParamsForReviewUrlPropsBase64Type,
} from '@stencil/hotels-types/src/details-types';

import {
  IUpdate_Query,
  UPDATE_QUERY,
  IToggleLoadingSegmentSlider,
  TOGGLE_LOADING_SEGMENT_SLIDER,
  IUpdateSegmentSlider,
  UPDATE_SEGMENT_SLIDER_DATA,
  IResetSegmentSliderData,
  RESET_SEGMENT_SLIDER,
  IErrorLoadingSegmentSlider,
  ERROR_LOADING_SEGMENT_SLIDER,
  RESET_SELECTED_PROPERTY,
  UPDATE_AUTOSUGGEST_OPENED_BY,
  UPDATE_CALENDAR_PROGRESSIVE_SEARCH_FORM_OPENED_BY,
  AutosuggestOpenedByPageType,
  UPDATE_PAGEHEADER_SEARCH_WIDGET_OPEN_STATE,
  IUpdatePageHeaderSearchWidgetOpenState,
} from './types';

export function updateQueryAction(actionData: IUpdate_Query['actionData']): IUpdate_Query {
  return {
    type: UPDATE_QUERY,
    actionData,
  };
}

export function updatePageHeaderSearchWidgetOpen(
  pageHeaderSearchWidgetOpenState: IUpdatePageHeaderSearchWidgetOpenState['payload']['isPageHeaderSearchWidgetOpen'],
) {
  return {
    type: UPDATE_PAGEHEADER_SEARCH_WIDGET_OPEN_STATE,
    payload: {
      isPageHeaderSearchWidgetOpen: pageHeaderSearchWidgetOpenState,
    },
  };
}

export function updateAutosuggestOpenedBy(page: AutosuggestOpenedByPageType['page']) {
  return {
    type: UPDATE_AUTOSUGGEST_OPENED_BY,
    payload: {
      page,
    },
  };
}

export function updateCalendarProgressiveSearchFormOpenedBy(
  page: AutosuggestOpenedByPageType['page'],
) {
  return {
    type: UPDATE_CALENDAR_PROGRESSIVE_SEARCH_FORM_OPENED_BY,
    payload: {
      page,
    },
  };
}

export function updateSelectedProperty({
  payload,
}: {
  payload: {
    propertyId?: string;
    propertyName?: string;
    propertyVendor?: string;
    hmd?: string;
    queryParamsForReviewUrlPropsBase64: QueryParamsForReviewUrlPropsBase64Type;
    descBlockInput: Assign<QueryParamsForReviewUrlPropsTypes, {paxString: string}>;
    ecomParams: {
      showPrice: number;
      currency: string;
    };
    selected: boolean;
    reviewType?: string;
  };
}) {
  return {
    type: UPDATE_SELECTED_PROPERTY,
    payload: payload,
  };
}

export function toggleLoadingSegmentSliderAction(
  actionData: IToggleLoadingSegmentSlider['actionData'],
): IToggleLoadingSegmentSlider {
  return {
    type: TOGGLE_LOADING_SEGMENT_SLIDER,
    actionData,
  };
}

export function errorLoadingSegmentSliderAction(
  actionData: IErrorLoadingSegmentSlider['actionData'],
): IErrorLoadingSegmentSlider {
  return {
    type: ERROR_LOADING_SEGMENT_SLIDER,
    actionData,
  };
}

export function updateSegmentSliderAction(
  actionData: IUpdateSegmentSlider['actionData'],
): IUpdateSegmentSlider {
  return {
    type: UPDATE_SEGMENT_SLIDER_DATA,
    actionData,
  };
}

export function resetSegmentSliderDataAction(): IResetSegmentSliderData {
  return {
    type: RESET_SEGMENT_SLIDER,
  };
}

export function resetSelectedProperty() {
  return {
    type: RESET_SELECTED_PROPERTY,
  };
}
